/*
 * Copyright © 2025. Legalbird eine Marke der Legalbird GmbH
 */

import applicationFormStyle from "../../Form/applicationFormStyle";
import { scrollToAnchor, submit } from "../../../theme/commonStyle";
import { Theme } from "@mui/material";

const partnerCheckinStyle = {
  ...applicationFormStyle,
  scrollToAnchor,
  submit,
  formPaper: {
    padding: { xs: "20px", lg: "20px 40px" },
  },
  button: (theme: Theme) => ({
    [theme.breakpoints.up("md")]: {
      marginTop: "5px",
    },
  }),
  heading: {
    textAlign: "center",
  },
  classification: {
    width: "100%",
  },
  email: {
    width: "100%",
  },
  default: {},
  grey: {
    backgroundColor: "background.contrast",
  },
  advantagesGridContainer: (theme: Theme) => ({
    [theme.breakpoints.down("md")]: {
      marginTop: "10px",
      marginBottom: "15px",
    },
  }),
  advantagesGridItems: (theme: Theme) => ({
    [theme.breakpoints.down("md")]: {
      padding: "0 !important",
    },
    /* Special Case Breakpoint */
    "@media (max-width: 750px)": {
      maxWidth: "100%",
      flexBasis: "100%",
    },
  }),
  advantagesContainer: {
    width: "fit-content",
  },
  checkmark: {
    color: "primary.main",
    verticalAlign: "middle",
    fontSize: "2rem",
  },
  advantages: {
    verticalAlign: "sub",
  },
};

export default partnerCheckinStyle;
